webpackJsonp([60573171963332],{

/***/ 896:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"skid row","www_url":"http://www.i-love-u.ch","thema":"Skid Row","issue_month":"December","issue_year":2006,"issue_date":200612,"artist":"luzora","location":"Schweiz","email":"luzora@hotmail.com","id":"contribution_250","media_type":"textz","position_in_section":1,"media_uri":"media/2006/December/textz/row.jpg","media_th_uri":"media/2006/December/textz/tn_row.jpg","still_image_count":2,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_250"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200612-textz-1-07412020fba150fe5438.js